import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router';
import { browserHistory } from 'react-router';

import { Layout, Menu, Breadcrumb, Icon } from 'antd';
import { menus } from 'constants/menu';
import cn from 'classnames';
import Utils from 'utils/utils';
import { logoff } from 'data/user';
// import Breadcrumbs from 'react-breadcrumbs';
// import { Sider } from Layout;
import _ from 'lodash';
import classes from './styles/Admin.module.scss';
// import { logoff } from 'redux/modules/user';
// import { addMessage, addNotification } from 'redux/modules/chat';
const { Sider, Header, Content, Footer } = Layout;
const SubMenu = Menu.SubMenu;

class Admin extends Component {
  constructor() {
    super();
    this.renderMenu = this.renderMenu.bind(this);
    this.state = {
      collapsed: false,
      index: 0,
    };
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  renderMenu(menu) {
    if (menu.value === 'logoff') {
      return (
        <Menu.Item key={menu.value}>
          <div
            onClick={() => {
              logoff().then(() => {
                Utils.deleteToken();
                window.location.replace('/login');
              });
            }}
          >
            {menu.icon && <Icon type={menu.icon} />}
            <span className="nav-text">{menu.label}</span>
          </div>
        </Menu.Item>
      );
    }

    if (menu.submenus) {
      return (
        <SubMenu
          key={menu.value}
          title={
            <span>
              <Icon type={menu.icon} />
              <span className="nav-text">{menu.label}</span>
            </span>
          }
        >
          {menu.submenus.map(this.renderMenu)}
        </SubMenu>
      );
    }
    return (
      <Menu.Item key={menu.value}>
        <Link to={menu.route}>
          {menu.icon && <Icon type={menu.icon} />}
          <span className="nav-text">{menu.label}</span>
        </Link>
      </Menu.Item>
    );
  }
  renderBreadcrumb() {
    function itemRender(route, params, routes, paths) {
      let last;
      let noNextRouteLink;
      const thisRoute = routes[routes.indexOf(route)];
      if (routes.indexOf(route) === routes.length - 1) {
        last = true;
      } else {
        last = false;
        noNextRouteLink = routes[routes.indexOf(route) + 1].noLink;
      }
      const key = routes.indexOf(route);
      const name = Utils.getBreadcrumbName(route, params);
      if (!name) return <span key={key} />;
      // const name = Utils.getBreadcrumbName(route, params);
      let linkTo = `/${paths.join('/')}`;
      if (thisRoute.replaceFrom && thisRoute.replaceTo) {
        linkTo = linkTo.replace(thisRoute.replaceFrom, thisRoute.replaceTo);
      }

      return last || noNextRouteLink ? (
        <span key={key}>{name}</span>
      ) : (
        <Link to={linkTo} key={key}>
          {name}
        </Link>
      );
    }
    // console.log(activeMenu);
    return <Breadcrumb key={'breadcrumb'} routes={this.props.routes} params={this.props.params} itemRender={itemRender} />;
  }

  render() {
    const selectedKey = _.find(menus, { route: this.props.location.pathname }) || { value: '' };
    return (
      <Layout className={classes.mainLayout} theme="dark">
        <Sider trigger={null} collapsible collapsed={this.state.collapsed} theme="light">
          {this.state.collapsed ? <div className={cn('tp-logo-teachpot-only fa-25x text-center', classes.miniLogo)} /> : <div className={cn('tp-logo-teachpot fa-25x', classes.logo)} />}
          <Menu mode={this.state.collapsed ? 'vertical' : 'inline'} selectedKeys={[selectedKey.value]}>
            {menus.map(this.renderMenu)}
          </Menu>
        </Sider>
        <Layout>
          <Header className={classes.header}>
            <Icon className="trigger" type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'} onClick={this.toggle} />
            <div className={classes.user}>
              <Icon type="user" />
              &nbsp;
              <span>{_.get(this.props, 'user.displayName')}</span>
            </div>
          </Header>
          <Content className={classes.rightContainer}>
            {
              // this.renderBreadcrumb()
            }
            <div className={classes.contentContainer}>{React.cloneElement(this.props.children, { BreadCrumb: this.renderBreadcrumb() })}</div>
          </Content>
          <Footer>© TeachPot.com 2020</Footer>
        </Layout>
      </Layout>
    );
  }
}
export default connect(
  (state) => ({
    user: _.get(state, 'user.me'),
  }),
  {},
)(Admin);
